<template>
    <div>
        <div v-if="in_search">
            <div class="msg-race--wrapper" v-if="msg_starting_grids">
                <div class="msg-race--wrapper--body" v-for="msg in msg_starting_grids" :key="msg">
                    <div v-html="msg"></div>
                </div>
            </div>
            <b-form-input v-model="testo" :placeholder="$t('verifica_stato_iscrizioni.placeholder')"
                          @input="updateTextRicerca"></b-form-input>

            <div v-if="atleti.tot > 0">
                <div class="d-flex align-items-center pt-3 d-block d-sm-none">
                    <div class="pr-4 pl-2">
                        <img src="../assets/svg/hand-swipe.svg" alt="handSwipe" height="30">
                    </div>
                    <div class="d-flex justify-content-center">
                        <span class="text-center">{{$t('athlete_details.message')}}</span>
                    </div>
                </div>
                <div class="table-responsive mt-4 small">
                    <table class="table table-striped">
                        <tr class="text-center">
                            <th class="text-left">{{$t('athlete_details.athlete')}}</th>
                            <th>{{$t('athlete_details.event')}}</th>
                            <th>{{$t('athlete_details.bib')}}</th>
                            <th>{{$t('athlete_details.country')}}</th>
                            <th>{{$t('athlete_details.status')}}</th>
                            <!--<th colspan="2" class="text-center">{{$t('athlete_details.verify')}}</th>-->
                        </tr>
                        <tr v-for="atl in atleti.data" :key="atl.ID" @click="verifica(atl)">
                            <td style="vertical-align:middle;" class="text-left">{{atl.Name}} {{atl.Surname}}<span
                                    class="d-block text-dark font-weight-bold">{{atl.ClubName}}</span></td>
                            <td style="vertical-align:middle;" class="text-center">{{atl.EventDescription}}</td>
                            <td style="vertical-align:middle;" class="text-center">
                                <div class="bib-string" :style="{'background-color':atl.GridColor}">
                                    <span v-if="atl.BibString">{{atl.BibString}}</span>
                                    <span v-else>{{$t('not_available')}}</span>
                                </div>
                                <!--<div v-else class="bib-string">{{$t('not_available')}}</div>-->
                            </td>
                            <td style="vertical-align:middle;" class="text-center"><img
                                    :src="`${publicPath}flags/${atl.Country}.gif`" :alt="atl.Country"
                                    v-if="atl.Country"></td>
                            <td style="vertical-align:middle;" class="text-center">
                                <span v-if="atl.EntryValidation === -1" class="traffic-light text-success display-4"
                                      v-b-tooltip.hover.right :title="$t('athlete_details.status_coming')">
                                    <img src="../assets/svg/hourglass-icon.svg" id="tooltip-EntryValidation-coming"
                                         height="25" alt="">
                                    <!--<span class="traffic-light__blink-light">-->
                                    <!--<img src="../assets/svg/traffic-light-blinker-on.svg" height="25" alt="">-->
                                    <!--</span>-->
                                </span>

                                <span v-if="atl.EntryValidation === 0" class="text-success btn-disable display-4"
                                      v-b-tooltip.hover.right :title="$t('athlete_details.no_actions')">
                                    <img src="../assets/svg/traffic-light-green.svg" id="tooltip-EntryValidation-ok"
                                         height="25" alt="">
                                </span>

                                <span v-if="atl.EntryValidation >=1 && atl.EntryValidation <= 3"
                                      class="text-orange display-4" v-b-tooltip.hover.right
                                      :title="$t('athlete_details.status_alert')">
                                    <img src="../assets/svg/traffic-light-orange.svg" id="tooltip-EntryValidation-alert"
                                         height="25" alt="">
                                </span>

                                <span v-if="atl.EntryValidation >=4" class="text-red display-4" v-b-tooltip.hover.right
                                      :title="$t('athlete_details.status_problem')">
                                    <img src="../assets/svg/traffic-light-red.svg" id="tooltip-EntryValidation-problem"
                                         height="25" alt="">
                                </span>
                            </td>
                            <!--<td style="vertical-align:middle;" class="text-center">-->
                            <!--<div class="d-inline-block btn-sm btn-primary small font-weight-normal" v-if="atl.Documents.length > 0">-->
                            <!--{{$t('athlete_details.go')}}-->
                            <!--</div>-->
                            <!--<div v-b-tooltip.hover :title="$t('athlete_details.no_actions')" class="d-inline-block btn-sm btn-primary btn-disable small font-weight-normal" v-if="atl.Documents.length === 0">-->
                            <!--{{$t('athlete_details.go')}}-->
                            <!--</div>-->
                            <!--</td>-->
                        </tr>
                    </table>
                </div>
                <div class="col-md-12 text-center text-muted mt-1" v-if="(atleti.tot > atleti.numPerPage)">
                    <b-pagination class="justify-content-center" :total-rows=Number(atleti.tot) v-model="atleti.pag"
                                  :per-page="atleti.numPerPage"
                                  @change="updateRicerca"></b-pagination>
                    <!--{{atleti.data.length}} di -->
                    {{atleti.tot}}
                </div>
            </div>
            <div class="px-3 pt-2 pb-3 text-muted small text-uppercase" v-else>
                <div v-if="solo_pettorale">{{$t('athlete_details.only_bibstring')}}</div>
                <span v-else-if="not_found">{{$t('athlete_details.no_record_found_for')}} {{search_text}}</span>
                <span v-else-if="testo.length > 0">{{$t('athlete_details.search_in_progress')}}.</span>
            </div>
        </div>
        <div v-if="in_dettaglio">
            <div class="pb-3 text-center">
                <span class="mb-1 small text-secondary">{{domanda.domanda}}</span>
            </div>
            <b-form @submit="onSubmit">
                <div class="d-flex align-items-center justify-content-start">
                    <b-input class="form-control" type="text" v-model="domanda.password" required></b-input>
                    <b-button type="submit" class="ml-2" variant="primary">{{$t('athlete_details.send')}}</b-button>
                </div>
            </b-form>
            <div class="pt-2">
                {{atleta.Name}} {{atleta.Surname}}
            </div>
            <div class="mt-5 d-flex align-items-center justify-content-between">
                <a class="btn btn-light float-left" @click="onShow">{{$t('athlete_details.back_to_search')}}</a>
            </div>
        </div>
        <div v-if="in_info">
            <div v-for="doc in atleta.Documents" :key="doc.Body">
                <div class="p-2 text-left">
                    <p>{{doc.Name}}</p>
                    <p v-if="doc.Body" style="white-space:pre-wrap;">{{doc.Body}}</p>
                </div>
                <div class="mt-5 d-flex align-items-center justify-content-between">
                    <a class="btn btn-light" @click="onShow">{{$t('athlete_details.back_to_search')}}</a>
                    <a class="btn btn-primary" :href="doc.LinkURL" v-if="doc.LinkURL" target="_blank">{{$t('athlete_details.confirmation_letter')}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce'
    import BaseVue from '../views/BaseVue'
    import {EventBus} from '../util/event-bus.js'

    export default {
        extends: BaseVue,
        name: 'VerificaIscrizione',
        props: ['data'],
        data() {
            return {
                publicPath: process.env.BASE_URL,
                testo: '',
                not_found: false,
                solo_pettorale: false,
                search_text: '',
                birthdate: '',
                in_dettaglio: false,
                in_info: false,
                in_search: true,
                atleti: {
                    data: [],
                    sport: -1,
                    nazione: -1,
                    pag: 1,
                    tot: 0,
                    numPerPage: 5,
                    testo: '',
                    picker: {
                        startDate: this.$moment(),
                        endDate: this.$moment().add(1, 'year'),
                    }
                }, atleta: null,
                domanda: {
                    domanda: '',
                    risposta: '',
                    password: ''
                }
            }
        },
        mounted() {
            EventBus.$on('verifica_onShow', this.onShow)
            EventBus.$on('verifica_onHide', this.onHide)

        },
        computed: {
            msg_starting_grids() {
                if (!this.data || this.data.InfoMessages.length <= 0) return false
                let msgs = []
                for (let i = 0; i < this.data.InfoMessages.length; i++)
                    if (this.data.InfoMessages[i].Type === 3)
                        msgs.push(this.data.InfoMessages[i].Text)
                if (msgs.length <= 0) return false
                return msgs
            }
        },
        methods: {
            updateTextRicerca: debounce(async function () {
                this.not_found = false
                this.atleti.pag = 1
                await this.$nextTick()
                this.updateRicerca(this.atleti.pag)
            }, 1000),
            async updateRicerca(pag) {
                if (this.testo.length <= 0) {
                    this.atleti.data = []
                    this.atleti.tot = false
                    this.solo_pettorale = false
                    return false
                }

                let url = this.data.ID + '/search/athlete/§all/' + encodeURIComponent(this.testo)
                if (this.testo.length < 3) {
                    this.solo_pettorale = true
                    url = this.data.ID + '/search/athlete/bibstring/' + encodeURIComponent(this.testo)
                }


                url += '/' + ((pag - 1) * this.atleti.numPerPage + 1) + '/' + this.atleti.numPerPage // Paginazione
                let data = await this.get(url)
                this.atleti.data = data.Athletes
                this.atleti.tot = data.Status.RecordCount
                this.search_text = this.testo
                this.not_found = (this.atleti.tot <= 0)
            }, verifica(atl) {
                if (atl.Documents.length <= 0) {
                    this.$notify({
                        type: 'alert-info',
                        text: this.$t('athlete_details.athlete_ok', {name: atl.Name, surname: atl.Surname})
                    })
                    return false
                }

                this.in_dettaglio = true
                this.in_search = false
                this.in_info = false
                this.birthdate = ''
                this.atleta = atl

                // Estraggo la domanda e la risposta
                this.domanda.domanda = atl.Documents[0].PasswordPrompt
                this.domanda.risposta = atl.Documents[0].AccessPassword

                if (this.admin) {
                    this.in_info = true
                    this.in_dettaglio = false
                }

            }, onShow() {
                this.in_dettaglio = false
                this.in_search = true
                this.in_info = false
                //this.testo = ''
                this.atleta = null
            }, onSubmit(e) {
                e.preventDefault()
                if (this.domanda.password == this.domanda.risposta) {
                    this.in_dettaglio = false
                    this.in_info = true
                } else {
                    // this.in_dettaglio = false
                    this.domanda.password = ''
                    this.$notify({type: 'alert-danger', text: this.$t('errors.invalid_password')})
                }
            }, onHide(evt) {
                if (this.in_search)
                    return true

                evt.preventDefault()
                if (this.in_info) {
                    this.in_info = false
                    this.in_dettaglio = true
                }
                else if (this.in_dettaglio) {
                    this.in_dettaglio = false
                    this.in_search = true
                }
            }
        }
    }
</script>

<style scoped>

</style>
